import "./borradorNomina.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import "./../login/login.scss";
import Titulo from "../../components/atoms/titles/Titulo";

import { useNavigate, useLocation } from "react-router-dom";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import DataTable from "react-data-table-component";
import ConstantesTabla from "../../utils/ConstantesTabla";
import {
  getJSON
} from "../../components/services/NominasService";
import {
  SpinnerCircle
} from "../../components/atoms/spinner/Spinner";
import Header from "../../components/molecules/header/Header";
import { formateoNumeroEuro } from "../../utils/Utils";
import Footer from "../../components/molecules/footer/Footer";
import { useLocalStorage } from "../../hooks/useLocalStorage";

const BorradorNomina = (object) => {
  const [token] = useLocalStorage("token", "");
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [hayNomina, setHayNomina] = useState(false);


  let navigate = useNavigate();
  // const getTotals = (data, key) => {
  //   let total = 0;
  //   data.forEach((item) => {
  //     total += item[key];
  //   });
  //   return total;
  // };
  const [datos, setDatos] = useState();
  const meses = [
    "",
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];
  // const detalle = useState(data.detalle);

  useEffect(() => {
    setHayNomina(false);
    if (location?.state) {
      getJSON(location?.state.year, location?.state.month).then((data) => {
        
        
        setDatos(data);

        // Definir las filas vacías que se desean insertar
        const filasVaciasTituloAtrasos = [
          { codigo: "", concepto: "", uniBase: null, porcentaje: null, devengo: null, retencion: null, codigoCon: null, vTipret: null, vTipcon: null, vTipatr: null, anyodes: null, mesdes: null },
          { codigo: "", concepto: "**** ATRASOS ****", uniBase: null, porcentaje: null, devengo: null, retencion: null, codigoCon: null, vTipret: null, vTipcon: null, vTipatr: null, anyodes: null, mesdes: null },
          { codigo: "", concepto: "", uniBase: null, porcentaje: null, devengo: null, retencion: null, codigoCon: null, vTipret: null, vTipcon: null, vTipatr: null, anyodes: null, mesdes: null }
        ];

        // Buscar el índice del primer registro con `vTipret = "A"`
        const indiceAtrasos = data.detalles?.findIndex(row => row.vTipret === "A");

        // Si se encuentra un registro con `vTipret = "A"`, insertar filas vacías antes de ese registro
        if (indiceAtrasos !== -1) {
          data.detalles?.splice(indiceAtrasos, 0, ...filasVaciasTituloAtrasos);
        }

        // Añadir la fila de totales
        data?.detalles?.push({
          codigo: "TOTALES",
          devengo: data.iTotDev,
          retenciones: data.iTotRet,
        });

        // Verificar que no haya errores y luego cambiar el estado de carga
        if (!data.toString().startsWith("Error:")) {
          setHayNomina(true);
          setLoading(true);
        }

        // Actualizar el estado con los datos modificados
        setDatos(data);
      });
      
    } else {
      navigate("/home");
    }
  }, [location?.state, navigate, token]);

  // const descargar = (mes, anyo) => {
  //   setDescargandoPDF(true);
  //   
  //   getPDFBorradorNomina(mes, anyo).then((data) => {
  //     
  //     if (!data.toString().startsWith("Error:")) {
  //       const file = new Blob([data], {
  //         type: "application/pdf",
  //       });
  //       if (file.size !== 0) {
  //         setDescargandoPDF(false);
  //         const fileURL = URL.createObjectURL(file);
  //         const link = document.createElement("a");
  //         link.href = fileURL;
  //         link.download = `NOM_${mes}_${anyo}.pdf`;
  //         link.click();
  //         // link.remove();
  //         
  //         // setShowFeedback(false);
  //       } else {
  //         // setShowFeedback(true);
  //       }
  //     } else {
  //       // setShowFeedback(true);
  //     }
  //   });
  // };

  return (
    <>
      <div className="vh-100" role="main" data-landmark-index="4">
        <Header></Header>
        <div
          className="container d-flex flex-column min-vh-100 card mt-5"
          id="inicio"
        >
          <div className="my-auto">
            {loading ? (
              <>
                <div className="container-login p-2">
                  <Titulo titulo={"Nómina"} tipo={"tituloPagina"} />
                  <div className="separador"></div>
                  <div className="container mt-5">
                    <p className="titulo d-flex flex-column">
                      Esta información no es vinculante y se emite únicamente a
                      efectos de consulta.
                    </p>
                    <div className="gridConsCen">
                      <p className="titulo_subtit concepto fw-bold text-black titCons">
                        CONSEJERÍA DE{" "}
                      </p>
                      <div className="textCons">
                        <span className="variable">{datos.consejeria}</span>
                      </div>
                      <p className="titulo_subtit concepto fw-bold text-black titCen">
                        CENTRO DIRECTIVO{" "}
                      </p>
                      <div className="textCen">
                        <span className="variable ">{datos.centro}</span>
                      </div>
                    </div>
                    <div className="titulo d-flex flex-column align-items-center mt-3">
                      <p className="titulo_subtit concepto">
                        RETRIBUCIONES CORRESPONDIENTES AL MES DE{" "}
                        <span className="variable">{meses[datos.mes]}</span> y
                        AÑO <span className="variable">{datos.anyo}</span>
                      </p>
                    </div>
                    <div className="datosNomina">
                      {dataNomina(
                        "nombreNom ms-0 me-1 my-1",
                        "APELLIDOS Y NOMBRE",
                        datos.nombre
                      )}
                      {dataNomina(
                        "dniNom ms-1 me-0 my-1",
                        "Nº DNI",
                        `${datos.dni}${datos.letNiep}`
                      )}
                      {dataNomina(
                        "domicilioNom my-1",
                        "DOMICILIO, LOCALIDAD Y CODIGO POSTAL",
                        datos.domicilio
                      )}
                      {dataNomina(
                        "nNominaNom ms-0 me-1 my-1",
                        "Nº NOMINA C.",
                        datos.numNomina
                      )}
                      {dataNomina("grupoNom m-1", "GRUPO", datos.grupo)}
                      {dataNomina("nivelNom m-1", "NIVEL", datos.nivel)}
                      {dataNomina("ceNom m-1", "C.E.", datos.complemento)}
                      {dataNomina("cNivelNom m-1", "C. NIVEL", datos.comNivel)}
                      {dataNomina(
                        "categoriaNom ms-1 me-0 my-1",
                        "CATEGORIA",
                        datos.categoria
                      )}
                      {dataNomina(
                        "nPatronalNom ms-0 me-1 my-1",
                        "Nº PATRONAL",
                        datos.nPatronal
                      )}
                      {dataNomina(
                        "afiliacionNom m-1",
                        "AFILIACION S.S.",
                        datos.afiliacion
                      )}
                      {dataNomina(
                        "cotizacionNom m-1",
                        "G. COTIZACIÓN",
                        datos.gCot
                      )}
                      {dataNomina(
                        "epigrafeNom m-1",
                        "EPIGRAFE",
                        datos.epigrafe
                      )}
                      {dataNomina(
                        "nDiasNom ms-1 me-0 my-1",
                        "Nº DIAS",
                        datos.nDias
                      )}
                    </div>
                    <div className="dataTableNomina">
                      <DataTable
                        className="table-responsive"
                        columns={[...ConstantesTabla.columnasTablaNomina]}
                        data={datos.detalles}
                        noDataComponent={
                          <span>No se encontró ninguna solicitud</span>
                        }
                        customStyles={ConstantesTabla.customStyles}
                      // fixedHeader
                      />
                    </div>
                    <div className="d-flex mt-2 align-items-end flex-row-reverse justify-content-between">
                      <div className="fondo p-2 d-flex align-items-center flex-column">
                        <p>LIQUIDO A PERCIBIR: </p>
                        <p className="fw-bold">
                          {formateoNumeroEuro(datos.iLiquido) !== "0,00"
                            ? formateoNumeroEuro(datos.iLiquido)
                            : null}
                        </p>
                      </div>
                      <p>
                        La presente nómina será ingresada en:{" "}
                        <span className="fw-bold">{datos.cuenta}</span>
                      </p>
                    </div>
                    <div className="d-flex justify-content-between"></div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {datos !== undefined ? (
                  <>
                    <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column">
                      {datos}
                      {/* <Button
                        id="btnCerrarConsultaIRPF"
                        clases="btn-card mt-3"
                        nombre="Volver"
                        tipo="button"
                        funcion={() => {
                          navigate("/home");
                        }}
                      /> */}
                    </div>
                  </>
                ) : (
                  <SpinnerCircle></SpinnerCircle>
                )}
              </>
            )}
          </div>
        </div>

        {/* botones */}
        <div className="d-flex justify-content-center gap-3 my-3 row">
          <div className="col-md-3 order-2 order-md-1">
            <button
              id="volver"
              className="btnRed rounded px-4 py-2"
              type="button"
              onClick={() => navigate("/home")}
            >
              <i className="fa-solid fa-rotate-left me-2"></i> Volver
            </button>

          </div>
          {hayNomina ? (<>
            <div className="col-md-3 order-1 order-md-2">
              <button
                id="imprimir"
                className="btn btn-primary rounded px-4 py-2"
                type="button"
                onClick={() => window.print()}
              >
                <i className="fa-solid fa-print me-2"></i> Imprimir
              </button>
            </div>
          </>) : null}

        </div>

        <Footer></Footer>
      </div>
    </>
  );
};

export default memo(BorradorNomina);
function dataNomina(clase, titulo, data) {
  return (
    <div className={clase}>
      <div className="nombreNom">
        <p className="fondo p-1 fw-bold">{titulo}</p>
        <p className="p-1">{data}</p>
      </div>
    </div>
  );
}
